import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_833zv9pdk2: FaireCollectionEntity = {
  token: "pbc_833zv9pdk2",
  type: "collection",
  name: "camping",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4895a1f804f55fda69a052a2810975a8f71bde170e1c9a5fe07c51bb4eff8027.jpeg",
  itemCount: 11,
  description:
    "Delight your customers with the camping watercolor collection that captures the adventure and nostalgia of the great outdoors—wildlife, catching fireflies, and cozy nights around the campfire. ",
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:22.244Z",
    importedBy: "entity-db-import-collections",
  },
};
